import * as yup from 'yup';
import { validateShipmentTrackingNumber } from '../../helpers/formHelpers/formHelpers';
import ITPostboxDelivery from '../../interfaces/postboxDelivery/postboxDelivery';

export const postboxDeliveryInitialValues: ITPostboxDelivery = {
	trackingnumber: '',
	customerEmail: '',
	phone: '',
	name: '',
	postbox: '',
	captchaValid: false,
};

export const postboxDeliverySchema = yup.object().shape({
	trackingnumber: yup
		.string()
		.min(10, 'trackingnumberMin')
		.max(13, 'trackingnumberMax')
		.test('validateTrackingNumber', 'trackingnumberWrong', trackingNumber =>
			validateShipmentTrackingNumber(trackingNumber)
		)
		.required('trackingnumberRequired'),
	customerEmail: yup.string().email('emailNotValid').required('emailRequired'),
	phone: yup
		.string()
		.required('phoneRequired')
		.matches(/^[6-8][0-9]*$/, 'phoneNotValid')
		.min(7, 'phoneMin')
		.max(15, 'phoneMax'),
	postbox: yup.string().required('postboxRequired'),
	// captchaValid: yup.boolean().test('is-valid-captcha', 'captcha-valid', value => value),
});
